/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan: NonNullable<unknown>, used: NonNullable<unknown>, limit: NonNullable<unknown>, credits: NonNullable<unknown> }} Coaching_Plan_LineInputs */

const en_coaching_plan_line = /** @type {(inputs: Coaching_Plan_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plan: ${i?.plan} · used this month: ${i?.used}/${i?.limit} · extra credits: ${i?.credits}`)
};

const id_coaching_plan_line = /** @type {(inputs: Coaching_Plan_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Paket: ${i?.plan} · terpakai bulan ini: ${i?.used}/${i?.limit} · kredit tambahan: ${i?.credits}`)
};

/**
* | output |
* | --- |
* | "Plan: {plan} · used this month: {used}/{limit} · extra credits: {credits}" |
*
* @param {Coaching_Plan_LineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const coaching_plan_line = /** @type {((inputs: Coaching_Plan_LineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Plan_LineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_coaching_plan_line(inputs)
	return en_coaching_plan_line(inputs)
});